// Strip common markdown markers so AI answers render as plain prose.
// Line breaks are preserved (the answer is shown as plain text, no v-html).
const stripMarkdown = function (text) {
  if (!text) return ''
  return text
    .replace(/\*\*(.*?)\*\*/g, '$1') // **bold**
    .replace(/\*(.*?)\*/g, '$1') //     *italic*
    .replace(/__(.*?)__/g, '$1') //     __bold__
    .replace(/_(.*?)_/g, '$1') //       _italic_
    .replace(/^#+\s+/gm, '') //         # headings
    .replace(/`([^`]+)`/g, '$1') //     `code`
    .replace(/^>\s+/gm, '') //          > quotes
}

export { stripMarkdown }
